// Route guard for the staff softphone (roadmap #41). Sends unauthenticated visitors to
// the login screen. The session is restored from storage at app boot (see App.tsx).
// While authenticated it also mounts the single-device watcher (StaffSessionGuard),
// which signs the staff out if the account is claimed on another device.
import { Navigate } from 'react-router-dom'
import { isStaffAuthenticated } from './staffAuth'
import StaffSessionGuard from './StaffSessionGuard'

const RequireStaffAuth = ({ children }: { children: JSX.Element }) => {
  if (!isStaffAuthenticated()) {
    return <Navigate to="/staff" replace />
  }
  return (
    <>
      <StaffSessionGuard />
      {children}
    </>
  )
}

export default RequireStaffAuth
